import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 92 92.001",
  "aria-hidden": "true",
  focusable: "false"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M45.385.004C19.983.344-.335 21.214.005 46.62c.34 25.392 21.208 45.714 46.61 45.376 25.4-.342 45.72-21.213 45.38-46.615-.34-25.393-21.21-45.715-46.61-45.376zm5.1 15.33c4.675 0 6.056 2.713 6.056 5.814 0 3.877-3.103 7.46-8.396 7.46-4.43 0-6.537-2.23-6.413-5.91 0-3.1 2.6-7.365 8.754-7.365zM38.494 74.75c-3.194 0-5.536-1.938-3.3-10.467l3.666-15.125c.638-2.424.745-3.392 0-3.392-.958 0-5.106 1.674-7.556 3.322l-1.598-2.617c7.774-6.49 16.712-10.298 20.545-10.298 3.196 0 3.728 3.78 2.132 9.594l-4.2 15.9c-.743 2.81-.423 3.78.32 3.78.96 0 4.1-1.167 7.187-3.59l1.81 2.424c-7.56 7.558-15.81 10.47-19.004 10.47z"
    }, null, -1)
  ])))
}
export default { render: render }